import { OnInit, EventEmitter, OnDestroy } from "@angular/core";
import { FormControl } from "@angular/forms";
import { FlyToCartService } from "../../services/fly-to-cart.service";
import { filter } from 'rxjs/operators';
var QuantityPickerComponent = /** @class */ (function () {
    function QuantityPickerComponent(flyToCartSvc) {
        this.flyToCartSvc = flyToCartSvc;
        this.quantityInput = new FormControl();
        this.value = 0;
        this.stepping = 1;
        this.minQuantity = 1;
        this.mode = 'catalog';
        this.quantityType = 'relative';
        this.quantityChanged = new EventEmitter();
    }
    QuantityPickerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.inputSubscription = this.quantityInput.valueChanges.pipe(filter(function (value) { return Number(value) > 0; })).subscribe(function (value) {
            _this.relativeQuantity = value;
            _this.absoluteQuantity = value * _this.stepping;
            // Directly emit to API if in checkout mode AND value of inputfield is different than value of @Input component
            if (_this.checkoutMode && (value !== (_this.value / _this.stepping))) {
                // Use setTimout() to give user time to finish typing (for example 10, or 100)
                setTimeout(function () {
                    _this.emitQuantity(_this.absoluteQuantity);
                }, 1000);
            }
        });
        this.setQuantity();
    };
    QuantityPickerComponent.prototype.ngOnDestroy = function () {
        this.inputSubscription.unsubscribe();
    };
    Object.defineProperty(QuantityPickerComponent.prototype, "checkoutMode", {
        get: function () {
            return this.mode.toLowerCase() === 'checkout';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuantityPickerComponent.prototype, "unit", {
        get: function () {
            return this.stepping || 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuantityPickerComponent.prototype, "showAbsoluteQuantity", {
        get: function () {
            return !this.checkoutMode && this.quantityType === 'relative';
        },
        enumerable: true,
        configurable: true
    });
    QuantityPickerComponent.prototype.plus = function () {
        this.relativeQuantity++;
        this.quantityInput.setValue(this.relativeQuantity);
    };
    QuantityPickerComponent.prototype.minus = function () {
        if (this.relativeQuantity - 1 >= 1) {
            this.relativeQuantity--;
            this.quantityInput.setValue(this.relativeQuantity);
        }
        else {
            this.setQuantity();
        }
    };
    QuantityPickerComponent.prototype.addToCart = function () {
        this.emitQuantity(this.absoluteQuantity);
        this.flyToCartSvc.animateFlyToCart(this.itemId, this.source);
        this.setQuantity();
    };
    QuantityPickerComponent.prototype.emitQuantity = function (absoluteQuantity) {
        if (!this.checkoutMode) {
            absoluteQuantity = absoluteQuantity + this.value;
        }
        this.quantityChanged.emit({
            quantity: absoluteQuantity,
            isEdited: false
        });
    };
    QuantityPickerComponent.prototype.setQuantity = function () {
        this.relativeQuantity = 1;
        // If in checkoutMode, display the number of items currently in cart.
        if (this.checkoutMode) {
            this.relativeQuantity = this.value / this.stepping;
        }
        this.absoluteQuantity = this.relativeQuantity * this.stepping;
        this.quantityInput.setValue(this.relativeQuantity);
    };
    return QuantityPickerComponent;
}());
export { QuantityPickerComponent };
